import React from "react";

import { Box, Slider, Typography } from "@material-ui/core";

export const MonthRangeSlider = ({
  monthRange,
  setMonthRange,
  label = "Forward Month Range",
  onChangeCommitted,
  ...props
}) => (
  <Box ml={1} mt={1}>
    <Typography variant="caption" color="textSecondary">
      {label}
    </Typography>
    <Slider
      aria-labelledby="month-range-slider"
      value={monthRange}
      onChange={(event, value) => setMonthRange(value)}
      onChangeCommitted={(event, value) =>
        onChangeCommitted ? onChangeCommitted(value) : undefined
      }
      step={1}
      min={1}
      max={12}
      marks={[
        { value: 1, label: "1" },
        { value: 3, label: "3" },
        { value: 6, label: "6" },
        { value: 12, label: "12" },
      ]}
      valueLabelDisplay="auto"
      {...props}
    />
  </Box>
);
